<template>
  <v-app-bar
    app
    flat
  >
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="toggleDrawer"
    />

    <v-container class="mx-auto py-0">
      <v-row align="center">
        <router-link to="/">
          <v-img
            :src="require('@/assets/Logo_Altenheim_lang_5cm.png')"
            class="mr-5"
            contain
            height="48"
            max-height="48"
            max-width="200"
          />
        </router-link>
        
        <v-row class="hidden-sm-and-down">
          <template v-for="item in this.$store.state.menuItems">
            <AppBarDropdown :tab="item" :key="item._uuid" v-if="item.dropdown" />
            <AppBarButton :tab="item" :key="item._uuid" v-if="!item.dropdown"/>
          </template>
        </v-row>
        
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  // Utilities
  import {
    mapGetters,
    mapMutations,
  } from 'vuex'

  export default {
    name: 'CoreAppBar',

    data() {
      return {
      }
    },

    computed: {
    },

    methods: {
      ...mapMutations(['toggleDrawer']),
  },
  components: {
      AppBarButton: () => import('./AppBarButton'),
      AppBarDropdown: () => import('./AppBarDropdown')
    },
  }
</script>
